// Module
var code = "<user-profile-display></user-profile-display>";
// Exports
module.exports = code;